import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, IconButton, Menu, MenuItem, Stack, Typography, } from "@mui/material";
import { DeleteOutlineRounded, EmailOutlined, LinkRounded, MoreVert, } from "@mui/icons-material";
import { useStoreFileViewerContext } from "../../hooks/context";
var ShareOptions = function (_a) {
    var object = _a.object, onDelete = _a.onDelete;
    var _b = useState(false), updating = _b[0], setUpdating = _b[1];
    var _c = useState(false), sending = _c[0], setSending = _c[1];
    var _d = useState(false), sent = _d[0], setSent = _d[1];
    var _e = useState(false), copied = _e[0], setCopied = _e[1];
    var _f = useStoreFileViewerContext(), apiRef = _f.apiRef, configurations = _f.configurations;
    var _g = useState(null), optionsEl = _g[0], setOptionsEl = _g[1];
    var handleRemove = function () {
        var _a;
        if (!(object === null || object === void 0 ? void 0 : object.id) || !((_a = apiRef === null || apiRef === void 0 ? void 0 : apiRef.share) === null || _a === void 0 ? void 0 : _a.delete))
            return;
        setUpdating(true);
        apiRef.share
            .delete({
            ids: [object.id],
        })
            .finally(function () {
            if (onDelete)
                onDelete();
            setUpdating(false);
            handleClose;
        });
    };
    var resendEmail = function () {
        var _a, _b, _c;
        if (!(object === null || object === void 0 ? void 0 : object.id) ||
            !((_a = apiRef === null || apiRef === void 0 ? void 0 : apiRef.share) === null || _a === void 0 ? void 0 : _a.send) ||
            !(object === null || object === void 0 ? void 0 : object.recipient_email) ||
            sending)
            return;
        setSending(true);
        var links = [
            { id: object.id, email: object.recipient_email },
        ];
        apiRef.share
            .send({
            sender_email: object.sender_email ||
                ((_b = configurations === null || configurations === void 0 ? void 0 : configurations.sender) === null || _b === void 0 ? void 0 : _b.email) ||
                "no-reply@pangea.cloud",
            sender_name: object.sender_name || ((_c = configurations === null || configurations === void 0 ? void 0 : configurations.sender) === null || _c === void 0 ? void 0 : _c.name),
            links: links,
        })
            .finally(function () {
            setSent(true);
            setSending(false);
        });
    };
    var copyLink = function () {
        if ((object === null || object === void 0 ? void 0 : object.link) && typeof object.link === "string") {
            navigator.clipboard.writeText(object.link);
            setCopied(true);
        }
    };
    var handleClose = function () {
        setOptionsEl(null);
    };
    useEffect(function () {
        if (copied) {
            setTimeout(function () {
                setCopied(false);
                setOptionsEl(null);
            }, 1000);
        }
    }, [copied]);
    useEffect(function () {
        if (sent) {
            setTimeout(function () {
                setSent(false);
                setOptionsEl(null);
            }, 1000);
        }
    }, [sent]);
    return (_jsxs(Box, { sx: { marginLeft: "auto" }, children: [_jsx(IconButton, { onClick: function (event) {
                    setOptionsEl(event.currentTarget);
                    event.stopPropagation();
                }, "data-testid": "Share-".concat(object === null || object === void 0 ? void 0 : object.id, "-Options-Btn"), children: _jsx(MoreVert, {}) }), _jsxs(Menu, { open: !!optionsEl, anchorEl: optionsEl, onClose: function () { return setOptionsEl(null); }, sx: {
                    ".MuiList-root": {
                        width: "200px",
                    },
                    button: {
                        justifyContent: "start",
                        paddingLeft: 2,
                    },
                    ".MuiButton-textPrimary": {
                        color: function (theme) { return theme.palette.text.primary; },
                    },
                }, children: [!!object.id && !!object.link && !!object.recipient_email && (_jsx(MenuItem, { onClick: resendEmail, disabled: sending || sent, children: _jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(EmailOutlined, { fontSize: "small" }), _jsx(Typography, { variant: "body2", children: sending
                                        ? "Sending email"
                                        : sent
                                            ? "Email sent"
                                            : "Resend email" })] }) })), !!object.id && !!object.link && !object.recipient_email && (_jsx(MenuItem, { onClick: copyLink, disabled: copied, children: _jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(LinkRounded, { fontSize: "small" }), _jsx(Typography, { variant: "body2", children: copied ? "Link copied" : "Copy link" })] }) })), _jsx(MenuItem, { onClick: handleRemove, disabled: updating, children: _jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(DeleteOutlineRounded, { fontSize: "small" }), _jsx(Typography, { variant: "body2", children: updating ? "Deleting" : "Remove" })] }) })] })] }));
};
export default ShareOptions;
